'use client'

import {FC, PropsWithChildren} from 'react'

import {SolutionCenterProvider} from '@/components/user-portal/context/SolutionCenterContext'
import {BrandProvider} from '@/components/user-portal/modals/brand/context/BrandContext'
import {MonitoringDrawerProvider} from '@/components/user-portal/monitoring/context/MonitoringDrawerContext'

const PortalLayout: FC<PropsWithChildren> = ({children}) => (
  <MonitoringDrawerProvider>
    <SolutionCenterProvider>
      <BrandProvider>{children}</BrandProvider>
    </SolutionCenterProvider>
  </MonitoringDrawerProvider>
)

export default PortalLayout
